import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = ["Handmade & curated", "One of one", "New drops weekly", "Made to last", "No two alike", "Beauty in the everyday"];

export const EditorialMarquee = () => (
    <div data-testid="editorial-marquee" className="border-b border-line bg-[#EFEAE0] py-6">
        <Marquee speed={25} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={i} className="mx-16 flex items-center gap-16 font-serif text-2xl italic text-espresso/80">
                    {item}
                    <Asterisk size={20} className="text-gold" />
                </span>
            ))}
        </Marquee>
    </div>
);
